import {FilterSymbolState} from "core/redux/filter/FilterReduxState";
import {SymbolType, TradeSymbol} from "platform/protocol/trading/symbol/TradeSymbol";
import {FilterUtil} from "core/util/FilterUtil";

export class SymbolUtil {

    public static decimals = (symbol: TradeSymbol): number => {
        if (symbol) {
            return parseInt(symbol.decimals, 10);
        }
        return 4;
    }

    public static step = (symbol: TradeSymbol): number => {
        const fraction: number = SymbolUtil.decimals(symbol);
        if (fraction === 3) {
            return 0.001;
        } else if (fraction === 2) {
            return 0.01;
        } else if (fraction === 1) {
            return 0.1;
        } else if (fraction === 0) {
            return 1;
        }
        return 0.0001;
    }

    public static symbolTypeTitle = (symbol: TradeSymbol): string => {
        return SymbolType[symbol?.symbolType];
    }

    public static filter = (symbols: TradeSymbol[], filterState: FilterSymbolState, searchValue: string): TradeSymbol[] => {
        const newSymbols = [];
        symbols?.forEach((symbol: TradeSymbol) => {
            const payload: TradeSymbol = FilterUtil.filterSymbol(filterState, symbol, searchValue);
            if (payload) {
                newSymbols.push(symbol);
            }
        });
        return newSymbols;
    }
}
